import MyHealth from "./MyHealth";
export default MyHealth;
